module.exports = __webpack_public_path__ + "img/ch8.262ebf05.jpeg";